<div
  class="sudoku-keyboard"
  [class.no-margin]="noMargin"
  [class.notes-mode]="notesMode"
  [class.flat-bottom]="keyboardLayout === SudokuKeyboardLayouts.FLAT_BOTTOM"
  [class.two-row-bottom]="keyboardLayout === SudokuKeyboardLayouts.TWO_ROW_BOTTOM"
  [class.default-right]="keyboardLayout === SudokuKeyboardLayouts.DEFAULT_RIGHT"
  [class.default-bottom]="keyboardLayout === SudokuKeyboardLayouts.DEFAULT_BOTTOM"
  [class.three-col-right]="keyboardLayout === SudokuKeyboardLayouts.THREE_COL_RIGHT"
>
  <div class="sudoku-keyboard-row" *ngIf="keyboardLayout === SudokuKeyboardLayouts.THREE_COL_RIGHT">
    <ion-button
      class="sudoku-keyboard-button notes-toggle-button"
      [tooltip]="'PUZZLE.button_bar.buttons.notes_toggle.tooltip' | translate" (click)="setNoteMode()"
    >
      <span class="notes-toggle-label">{{ 'PUZZLE.button_bar.buttons.notes_toggle.title' | translate }}</span>
      <ion-toggle class="notes-toggle-switch" color="secondary" [ngModel]="notesMode"></ion-toggle>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-button joker-button" (click)="solveField()"
      [disabled]="jokerCount === 0 || disableJokerButton"
      [tooltip]="'PUZZLE.button_bar.buttons.joker.tooltip' | translate"
    >
      <ion-icon name="color-wand-sharp" slot="icon-only"></ion-icon>
      <ion-badge class="joker-badge" size="small" color="secondary">
        {{ jokerCount }}
      </ion-badge>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-button delete-button"
      [disabled]="disableDeleteButton"
      (click)="keyPressed('')"
      [tooltip]="'PUZZLE.delete_button' | translate"
    >
      <ion-icon name="backspace-sharp" slot="icon-only"></ion-icon>
    </ion-button>
  </div>

  <div class="sudoku-keyboard-row">
    <ion-button
      class="sudoku-keyboard-value-button move-up move-left"
      [disabled]="enabledInputs.indexOf('1') === -1"
      (click)="keyPressed('1')"
    >
      <span class="sudoku-keyboard-button-value">1</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-up"
      [disabled]="enabledInputs.indexOf('2') === -1"
      (click)="keyPressed('2')"
    >
      <span class="sudoku-keyboard-button-value">2</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-up move-right"
      [disabled]="enabledInputs.indexOf('3') === -1"
      (click)="keyPressed('3')"
    >
      <span class="sudoku-keyboard-button-value">3</span>
    </ion-button>

    <ion-button
      class="sudoku-keyboard-value-button move-up move-right"
      *ngIf="keyboardLayout===SudokuKeyboardLayouts.TWO_ROW_BOTTOM"
      [disabled]="enabledInputs.indexOf('4') === -1"
      (click)="keyPressed('4')"
    >
      <span class="sudoku-keyboard-button-value">4</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-up move-right"
      *ngIf="keyboardLayout===SudokuKeyboardLayouts.TWO_ROW_BOTTOM"
      [disabled]="enabledInputs.indexOf('5') === -1"
      (click)="keyPressed('5')"
    >
      <span class="sudoku-keyboard-button-value">5</span>
    </ion-button>

    <ion-button
      class="sudoku-keyboard-button notes-toggle-button"
      *ngIf="keyboardLayout !== SudokuKeyboardLayouts.THREE_COL_RIGHT"
      [tooltip]="'PUZZLE.button_bar.buttons.notes_toggle.tooltip' | translate" (click)="setNoteMode()"
    >
      <span class="notes-toggle-label">{{ 'PUZZLE.button_bar.buttons.notes_toggle.title' | translate }}</span>
      <ion-toggle class="notes-toggle-switch" color="secondary" [ngModel]="notesMode" />
    </ion-button>
  </div>

  <div class="sudoku-keyboard-row" *ngIf="keyboardLayout !== SudokuKeyboardLayouts.TWO_ROW_BOTTOM">
    <ion-button
      class="sudoku-keyboard-value-button move-left"
      [disabled]="enabledInputs.indexOf('4') === -1"
      (click)="keyPressed('4')"
    >
      <span class="sudoku-keyboard-button-value">4</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button"
      [disabled]="enabledInputs.indexOf('5') === -1"
      (click)="keyPressed('5')"
    >
      <span class="sudoku-keyboard-button-value">5</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-right"
      [disabled]="enabledInputs.indexOf('6') === -1"
      (click)="keyPressed('6')"
    >
      <span class="sudoku-keyboard-button-value">6</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-button joker-button" (click)="solveField()"
      *ngIf="keyboardLayout !== SudokuKeyboardLayouts.THREE_COL_RIGHT"
      [disabled]="jokerCount === 0 || disableJokerButton"
      [tooltip]="'PUZZLE.button_bar.buttons.joker.tooltip' | translate"
    >
      <ion-icon name="color-wand-sharp" slot="icon-only" />
      <ion-badge class="joker-badge" color="secondary">
        {{ jokerCount }}
      </ion-badge>
    </ion-button>
  </div>
  <div class="sudoku-keyboard-row">

    <ion-button
      class="sudoku-keyboard-value-button move-down move-left"
      *ngIf="keyboardLayout===SudokuKeyboardLayouts.TWO_ROW_BOTTOM"
      [disabled]="enabledInputs.indexOf('6') === -1"
      (click)="keyPressed('6')"
    >
      <span class="sudoku-keyboard-button-value">6</span>
    </ion-button>

    <ion-button
      class="sudoku-keyboard-value-button move-down move-left"
      [disabled]="enabledInputs.indexOf('7') === -1"
      (click)="keyPressed('7')"
    >
      <span class="sudoku-keyboard-button-value">7</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-down"
      [disabled]="enabledInputs.indexOf('8') === -1"
      (click)="keyPressed('8')"
    >
      <span class="sudoku-keyboard-button-value">8</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-value-button move-down move-right"
      [disabled]="enabledInputs.indexOf('9') === -1"
      (click)="keyPressed('9')"
    >
      <span class="sudoku-keyboard-button-value">9</span>
    </ion-button>
    <ion-button
      class="sudoku-keyboard-button delete-button"
      *ngIf="keyboardLayout !== SudokuKeyboardLayouts.THREE_COL_RIGHT"
      [disabled]="disableDeleteButton"
      (click)="keyPressed('')"
      [tooltip]="'PUZZLE.delete_button' | translate"
    >
      <ion-icon name="backspace-sharp" slot="icon-only" />
    </ion-button>

    <ion-button
      class="sudoku-keyboard-button joker-button" (click)="solveField()"
      *ngIf="keyboardLayout === SudokuKeyboardLayouts.TWO_ROW_BOTTOM"
      [disabled]="jokerCount === 0 || disableJokerButton"
      [tooltip]="'PUZZLE.button_bar.buttons.joker.tooltip' | translate"
    >
      <ion-icon name="color-wand-sharp" slot="icon-only" />
      <ion-badge class="joker-badge" color="secondary">
        {{ jokerCount }}
      </ion-badge>
    </ion-button>
  </div>
</div>
